import { render } from "./Employees.vue?vue&type=template&id=23d83976&scoped=true"
import script from "./Employees.vue?vue&type=script&lang=js"
export * from "./Employees.vue?vue&type=script&lang=js"

import "./Employees.vue?vue&type=style&index=0&id=23d83976&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-23d83976"

export default script